import { RestMethod } from "../../_helpers/ApiConfig/RestMethod";
import FilterResponse, {
  FilterResponseV2,
} from "../../_helpers/FilterResponse";
const singleObj = "singleObj";
const version_type = 1;
const callApi = async (api, Method, data, type, objType) => {
  try {
    const response = await RestMethod[Method](api, data);
    if (type === version_type) {
      if (objType === singleObj) return response;
      const api_response = FilterResponse(response); //If respone 200 to 299 Then return
      return api_response.data;
    } else {
      const api_response = FilterResponseV2(response); //If respone 200 to 299 Then return
      return api_response.data[0]
        ? api_response.data[0]
        : objType === singleObj
        ? api_response
        : api_response.data;
    }
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
};

export const getVarietyByCommodity = (commodity_id) => {
  var reuestlink = `dtr/commodity/${commodity_id}/varieties`;
  return callApi(reuestlink, "GET", null, version_type, singleObj);
};

export const addCustomizeFilterTemplate = (data) => {
  var reuestlink = `/blockchain/banker/customized-filter-template`;
  return callApi(reuestlink, "POST", data, null, singleObj);
};

export const updateCustomizeFilterTemplate = (data, id) => {
  var reuestlink = `/blockchain/banker/customized-filter-template/${id}`;
  return callApi(reuestlink, "PUT", data, null, singleObj);
};

export const delteCustomizeFilterTemplate = (id) => {
  var reuestlink = `/blockchain/banker/customized-filter-template/${id}`;
  return callApi(reuestlink, "DELETE", null, null, singleObj);
};

export const getAllStates = (commodity_id) => {
  var reuestlink = `/dtr/states`;
  return callApi(reuestlink, "GET", null, version_type);
};

export const getAllCitiesByState = (id) => {
  var reuestlink = `/dtr/cities?state_id=${id}`;
  return callApi(reuestlink, "GET", null, version_type);
};

export const getAllCustomizeTemplate = (queryParam, offset, limit) => {
  var reuestlink = `/blockchain/banker/customized-filter-template?${
    limit ? "&offset=" + offset : ""
  }${limit ? "&limit=" + limit : ""}${
    queryParam ? "&filters=" + queryParam : ""
  }&sort=desc`;
  return callApi(reuestlink, "GET");
};

export async function sampleDownloadBlockchain() {
  var reuestlink =
    "/blockchain/banker/customized-filter-template-sample-download";
  try {
    const response = await RestMethod.GET(reuestlink);
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Customize-filter.csv");
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
    return response;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export const uploadCustomizeFileData = (data) => {
  var reuestlink = `/blockchain/banker/customized-filter-template-sample-upload`;
  return callApi(reuestlink, "POST", data, null, singleObj);
};
